import { useRef } from 'react';
import logoTransparente from '../../assets/logo-posgo.png';

const BrandLogo = ({ delay = 0 }) => {
    const tapCount = useRef(0);
    const tapTimer = useRef(null);

    const handleSecretTap = () => {
        tapCount.current += 1;
        if (tapTimer.current) clearTimeout(tapTimer.current);

        if (tapCount.current >= 5) {
            tapCount.current = 0;
            // Solo ENTRAR a pantalla completa. Para SALIR se usa el gesto de la
            // esquina + PIN (KioskExitGate); así el logo no permite salir sin PIN.
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(() => {});
            }
            return;
        }

        tapTimer.current = setTimeout(() => {
            tapCount.current = 0;
        }, 3000);
    };

    return (
        <>
            <style>{`
        @keyframes brandSlideIn {
          from {
            opacity: 0;
            transform: translateX(-50px) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translateX(0) scale(1);
          }
        }

        .brand-logo-container {
          animation: brandSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
          animation-delay: ${delay}s;
          animation-fill-mode: both;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .brand-logo-container:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 20px rgba(0,0,0,0.25);
        }

        .brand-logo-container:hover img {
          transform: rotate(5deg);
        }

        .brand-logo-container img {
          transition: transform 0.3s ease;
        }
      `}</style>

            <div
                className="brand-logo-container"
                onClick={handleSecretTap}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    left: '20px',
                    zIndex: 9999,
                    background: 'white',
                    padding: '10px 18px',
                    borderRadius: '14px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '14px',
                    pointerEvents: 'auto',
                    cursor: 'default',
                }}>
                <img
                    src={logoTransparente}
                    alt="PosGo"
                    style={{
                        height: '55px',
                        width: 'auto',
                        display: 'block'
                    }}
                />
                <span style={{
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    color: '#db2113',
                    fontFamily: 'Quicksand, sans-serif',
                    lineHeight: 1
                }}>
                    PosGo.cl
                </span>
            </div>
        </>
    );
};

export default BrandLogo;